import {
  useChannelActionContext,
  useChannelPreviewInfo,
  useChannelStateContext,
  useChatContext,
} from 'stream-chat-react';
import { ArrowBack, Close, Search } from '@mui/icons-material';
import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';
import { Dispatch, SetStateAction } from 'react';
import { LayoutStage } from './StreamChat';
import { IconButton } from '@mui/material';
import MembersDropdown from './MembersDropdown';

export default function CustomChannelHeader({ setLayout }: { setLayout: Dispatch<SetStateAction<LayoutStage>> }) {
  const { closeThread } = useChannelActionContext();
  const { channel } = useChannelStateContext();
  const { setActiveChannel } = useChatContext();
  const { displayTitle } = useChannelPreviewInfo({
    channel,
  });

  function onClose() {
    closeThread();
    setActiveChannel(undefined);
    setTimeout(() => setLayout('list'), 100);
  }

  return (
    <div className="str-chat__channel-header" style={{ alignItems: 'start' }}>
      {isPhoneOrHighScreen() && <ArrowBack onClick={onClose} />}
      <div className="str-chat__channel-header-end">
        <p className="str-chat__channel-header-title">{displayTitle} </p>
        <MembersDropdown />
      </div>
      <IconButton onClick={() => setLayout('search')} sx={{ backgroundColor: 'grey.300', position: 'relative' }}>
        <Search />
      </IconButton>
      {!isPhoneOrHighScreen() && <Close onClick={onClose} sx={{ cursor: 'pointer', marginTop: '7px' }} />}
    </div>
  );
}
